/**
 * Helpers for reading the per-deck localized fields produced by
 * `normalizeDeck` in lib/sanity.js (English plus `_ja` / `_ko` / `_zhHant` suffixes).
 *
 * Centralized so SampleDecks, DeckCard, DeckView, and Home all stay in sync if
 * the language code set changes.
 */

// App language code → suffix on the normalized deck object.
// `EN` has no suffix (it lives on the base field).
const LANG_SUFFIX = {
  EN: '',
  JP: '_ja',
  KR: '_ko',
  'ZH-HANT': '_zhHant',
};

function pick(deck, base, language) {
  if (!deck) return '';
  const suffix = LANG_SUFFIX[language] ?? '';
  return deck[`${base}${suffix}`] || deck[base] || '';
}

export function getDeckName(deck, language) {
  return pick(deck, 'name', language);
}

export function getDeckDescription(deck, language) {
  return pick(deck, 'description', language);
}

/** For inline video.title objects ({ en, ja, ko, zhHant }). */
export function getLocalizedString(value, language) {
  if (!value) return '';
  const key = { EN: 'en', JP: 'ja', KR: 'ko', 'ZH-HANT': 'zhHant' }[language] || 'en';
  return value[key] || value.en || '';
}
